import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, IconButton, Loading } from '@guildeducationinc/recess';
// import DeleteOutlineIcon from '@guildeducationinc/recess/icons/DeleteOutlineIcon';
import EditIcon from '@guildeducationinc/recess/icons/EditIcon';
import { Button } from '@mui/material';
import { useReports } from '@src/hooks/useReports';
import { DataTable, useLocale } from 'pe-core-frontend';
import { useNavigate } from 'react-router-dom';
export const ReportTemplates = ({ clientId }) => {
    const navigate = useNavigate();
    const { t, formatToLocalDatetime } = useLocale();
    const { items, loading, error } = useReports({
        clientId,
    });
    const handleEdit = (row) => {
        navigate(`/admin/clients/${clientId}/integrations/report-templates/${row.id}`);
    };
    return (_jsxs(Loading, { label: 'Reports', loaded: !loading, showChildrenWhileLoading: true, overlay: true, children: [error && (_jsx(Alert, { display: true, hideClose: true, type: 'danger', children: error.message })), _jsx("div", { className: 'flex flexJustify--end mb-4', children: _jsx(Button, { variant: 'contained', className: 'button button--primary margin--bottom_16', onClick: () => navigate(`/admin/clients/${clientId}/integrations/report-templates/new`), children: t('Add Report') }) }), _jsx(DataTable, { disableColumnMenu: true, disableRowSelectionOnClick: true, rows: items || [], hideFooter: true, columns: [
                    {
                        field: 'name',
                        headerName: t('Name'),
                        flex: 0.2,
                        sortable: false,
                    },
                    {
                        field: 'type',
                        headerName: t('Type'),
                        flex: 0.2,
                        sortable: false,
                        renderCell: ({ row }) => t(`reportType.${row.type}`),
                    },
                    {
                        field: 'isActive',
                        headerName: t('Is Active?'),
                        flex: 0.2,
                        sortable: false,
                        renderCell: ({ row }) => (row.isActive ? 'Yes' : 'No'),
                    },
                    {
                        field: 'lastRunStatus',
                        headerName: t('Last Run Status'),
                        flex: 0.2,
                        sortable: false,
                        renderCell: ({ value }) => (value ? t(`ReportStatus.${value}`) : ''),
                    },
                    {
                        field: 'lastRunAt',
                        headerName: t('Last Run At'),
                        flex: 0.2,
                        sortable: false,
                        renderCell: ({ value }) => value
                            ? formatToLocalDatetime(value, { dateStyle: 'short', timeStyle: 'medium' })
                            : '',
                    },
                    {
                        field: 'cronSchedules',
                        headerName: t('Schedules'),
                        flex: 0.2,
                        sortable: false,
                    },
                    {
                        field: 'action',
                        headerName: t('Action'),
                        renderCell: ({ row }) => (_jsx("div", { children: _jsx(IconButton, { label: 'Edit', appearance: 'minimal', icon: _jsx(EditIcon, { size: 20 }), onClick: () => handleEdit(row), className: 'margin--right_8' }) })),
                        width: 100,
                        sortable: false,
                    },
                ] })] }));
};
